module.exports = " <div class=\"card float-e-margins\"> <div class=card-title> <h1>Betaling</h1> </div> <div class=card-content> <div class=row> <div class=col-md-12> <p> Na het plaatsen van de bestelling krijg je van ons een bevestiging <br> per e-mail met daarin de totaalprijs inclusief verzendkosten en het bankrekeningnummer. </p> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/customerService/paying.vue
// module id = 652
// module chunks = 0